import request from 'utils/request_ajax';
import { routes, ASYNC_REPORTS_TYPE } from 'constants/config';

export const sendAsyncReportingAppRequest = params => {
  request
    .post(routes.ASYNC_REPORTS_REQUEST, {
      request_data: params,
    })
    .done(data => {
      request.getScript(routes.NOTIFICATIONS_LATEST);
    });
};

export const sendExportAllPeopleRequest = activeGroupId => {
  sendAsyncReportingAppRequest({
    type: ASYNC_REPORTS_TYPE.EXPORT_ALL_PEOPLE,
    group_id: activeGroupId,
  });
};

export const sendExportKnowledgeCheckAttemptsRequest = () => {
  sendAsyncReportingAppRequest({
    type: ASYNC_REPORTS_TYPE.EXPORT_KNOWLEDGE_CHECK_ATTEMPTS,
  });
};

export const sendExportAllActivitiesRequest = () => {
  sendAsyncReportingAppRequest({
    type: ASYNC_REPORTS_TYPE.ALL_ACTIVITIES_REPORT,
  });
};
